export default __webpack_public_path__ + "static/media/audi.d3c584dc.svg";